import { render, staticRenderFns } from "./CustomerWsuExtend.vue?vue&type=template&id=6f7dcacd&scoped=true&"
import script from "./CustomerWsuExtend.vue?vue&type=script&lang=js&"
export * from "./CustomerWsuExtend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7dcacd",
  null
  
)

export default component.exports